/**
 * Ícone semântico de cada aviso — usado no toast e na lista do sino,
 * para bater o olho e saber do que se trata.
 */
import {
  AlarmClock,
  BadgeCheck,
  Ban,
  BatteryWarning,
  Bell,
  CheckCircle2,
  ClipboardCheck,
  ClipboardList,
  FilePlus2,
  Gauge,
  Hourglass,
  MapPin,
  MessageCircle,
  PauseCircle,
  Satellite,
  Send,
  ShieldAlert,
  Siren,
  Timer,
  TimerOff,
  UserX,
  WifiOff,
  XCircle,
} from "lucide-react";

export const SEVERITY_COLOR = {
  critical: "#ef4444",
  warning: "#f59e0b",
  info: "#3b82f6",
};

const EVENT_ICON = {
  "alert.atrasado.activated": AlarmClock,
  "alert.vai_atrasar.activated": Timer,
  "alert.inercia.activated": Hourglass,
  "alert.sem_acionamento.activated": UserX,
  "dispatch.created": Send,
  "dispatch.accepted": CheckCircle2,
  "dispatch.rejected": XCircle,
  "dispatch.expired": TimerOff,
  "service.created": FilePlus2,
  "service.cancelled": Ban,
  "service.finished": BadgeCheck,
  "service.arrived_origin": MapPin,
  "service.arrived_waypoint": MapPin,
  "service.arrived_destination": MapPin,
  "service.arrival_validation_pending": ShieldAlert,
  "chat.message_received": MessageCircle,
  "checklist.execution_finished": ClipboardCheck,
  "telemetry.offline": WifiOff,
  "telemetry.speed_violation": Gauge,
  "telemetry.critical": BatteryWarning,
  "pause.overtime": PauseCircle,
};

/** Ícone declarado no catálogo para cada categoria (`CATEGORIES[].icon`). */
export const CATEGORY_ICON = {
  siren: Siren,
  send: Send,
  "clipboard-list": ClipboardList,
  satellite: Satellite,
  "pause-circle": PauseCircle,
  "message-circle": MessageCircle,
  "clipboard-check": ClipboardCheck,
};

export function eventIcon(eventKey, categoryIconName) {
  return (
    EVENT_ICON[eventKey] || CATEGORY_ICON[categoryIconName] || Bell
  );
}

export function severityColor(severity) {
  return SEVERITY_COLOR[severity] || SEVERITY_COLOR.info;
}
